module.exports = __webpack_public_path__ + "img/goTop.c0ed2b24.png";